import React from "react";
import { copyrightYear, versionName } from "../common";
import { Container } from "react-bootstrap";

const Footer = (props) => {
    return (<>
        <Container fluid className="p-2" style={{background: '#EBEAE4'}} >
            <div className='custom-container'>
                <small className="">&nbsp;
                    <div className="ms-2 float-start text-muted">Copyright @ {copyrightYear()}, All rights reserved with ClearDemand</div>
                    <div className="me-2 float-end">Version {versionName()}</div>
                </small>
            </div>
        </Container>
    </>);
};

export default Footer;